import axios from '../utils/axios'

export async function getProducts (contractor) {
  let { data } = await axios({
    url: '/v1/products?contractor=' + contractor,
    method: 'get'
  })
  return data
}
